import React, { useEffect } from 'react'

import { CloseButton } from '@local/do-secundo-closebutton'
import { RestaurantInfo } from '../RestaurantInfo/RestaurantInfo'
import { RestaurantConsumer } from '@local/do-secundo-restaurant-provider'
import { Progress } from '@local/do-secundo-progress'
import { ScrollToTop } from '../ScrollToTop/ScrollToTop'
import { ToastContainer } from 'react-toastify'
import { useAvailability } from '@local/do-secundo-availability-provider'
import { CartNotifications } from '../CartNotifications/CartNotifications'

import { Cart } from '../Cart/Cart'
import style from './CartPage.module.css'
import { isMobileSafari } from '../../browser_overrides'
import { ValidateCart } from '../ValidateCart/ValidateCart'
import { useCart } from '@local/do-secundo-cart-provider'

const { toastContainer, toastWrapper } = style

export const CartPage = () => {
  const { loading: availabilityLoading, orderingAvailable } = useAvailability()
  const { dispatch } = useCart()

  useEffect(() => {
    return () => {
      // when unmounting the CartPage, clear modification errors
      dispatch({ type: 'CLEAR_MODIFICATION_ERRORS' })
    }
  }, [dispatch])

  return (
    <div className={style.cartPage}>
      <RestaurantConsumer>
        {({ getRestaurantPath }) => (
          <>
            <ScrollToTop el={isMobileSafari ? document.body : undefined} />
            <div className={style.closeButton}>
              <CloseButton
                data-testid='close-button-cart-page'
                to={{
                  pathname: getRestaurantPath(),
                  search: ''
                }}
              />
            </div>
            {availabilityLoading ? (
              <Progress />
            ) : (
              <>
                <RestaurantInfo
                  orderingAvailable={orderingAvailable}
                  header='Your Order'
                  showDeliveryAddress
                />
                <div className={style.notification}>
                  {<ValidateCart />}
                  <CartNotifications />
                </div>
                <Cart
                  menuLink={getRestaurantPath()}
                  checkoutLink={getRestaurantPath('checkout')}
                  orderingAvailable={orderingAvailable}
                  rectifyApprovalRuleLink={getRestaurantPath()}
                />
              </>
            )}
            <ToastContainer
              hideProgressBar
              closeButton={false}
              className={toastContainer}
              toastClassName={toastWrapper}
              position={'top-center'}
            />
          </>
        )}
      </RestaurantConsumer>
    </div>
  )
}
CartPage.propTypes = {}

// eslint-disable-next-line import/no-default-export
export default CartPage
